import {WaitingView} from '@gongxigames/framework/slot/modules/waiting';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {Module} from '@gongxigames/framework/slot';

export class WaitingModule extends Module<WaitingView, GlobalEventsMapForBackwardCompatibility> {
    public static readonly NAME: symbol = Symbol('WaitingModule');
    public static readonly SHOW_POPUP: symbol = Symbol('WaitingModule.SHOW_POPUP');
    public static readonly HIDE_POPUP: symbol = Symbol('WaitingModule.HIDE_POPUP');

    protected setupEvents(): void {
        super.setupEvents();

        this.on(WaitingModule.SHOW_POPUP, this.view.showPopup.bind(this.view));
        this.on(WaitingModule.HIDE_POPUP, this.view.hidePopup.bind(this.view));
        this.on('General.ResourcesLoading.LOADED_ALL_RESOURCES', this.view.hidePopup.bind(this.view));
    }

    protected setupViews(): void {
        this.setView(WaitingView.NAME);
    }

    protected setupStates(): void {
    }
}
